export default __webpack_public_path__ + "static/static-ba203c8b6d256c673e82ce60f08447b7.jpg";